const DEALERLESS_SEGMENT_COUNT = 3;

export function hasDealerSegment(quoteRef: string | null | undefined): boolean {
    if (!quoteRef) {
        return false;
    }
    return quoteRef.split('-').length > DEALERLESS_SEGMENT_COUNT;
}
